import React from 'react'

export default function NewsTilePlaceholder() {
  return (
    <div className="news_block placeholder-glow">
        <div className="news_emoji_block">
            <div className="name_icon">
            <div className="d-flex align-items-center mb-2">
                <div className="placeholder bg-secondary placeholder-xs col-md-5" style={{ width: "220px" }}></div>
                <div style={{width: '200px'}} > </div>
                <div className="placeholder bg-secondary placeholder-xs col-md-3" ></div>
            </div>
            </div>

            <div className="news_content mt-3">
            <div className="placeholder col-8 mb-2" style={{ height: "14px" }}></div>
            <div className="placeholder bg-secondary placeholder-xs col-10" style={{ height: "10px" }}></div>
            <div className="placeholder bg-secondary placeholder-xs col-9" style={{ height: "10px" }}></div>
            </div>

            <div className="news_bottom_block d-flex justify-content-between mt-2">
            <div className="news_date_name_block d-flex align-items-center">
                <div className="placeholder bg-secondary placeholder-xs col-3" style={{ height: "12px", width: '25px' }}></div>
            </div>
            </div>

            <div className="news_content d-flex mt-3">
            <div className="placeholder bg-secondary placeholder-xs col-md-3 mb-2 mr-1" style={{ width: "100px", height: '9px' }}></div>
            <div className="placeholder bg-secondary placeholder-xs col-md-2 mr-1" style={{ width: "10px", height: '9px' }} ></div>
            <div className="placeholder bg-secondary placeholder-xs col-md-3 mr-1" style={{ width: "100px", height: '9px' }}></div>
            </div>

        </div>
    </div>
  )
}
